import { useMemo } from "react";
import { ConnectProto } from "@racoon/api";

export const useShiftOptions = (data?: ConnectProto.DriverOnShift[]) => {
  const drivers = useMemo(() => {
    const driverMap = new Map<number, { id: string; name: string }>();

    data?.forEach((shift) => {
      if (shift.driver) {
        const driverId = Number(shift.driver.id);
        const driverName = `${shift.driver.firstName} ${shift.driver.lastName}`.trim();

        if (!driverMap.has(driverId) && driverName && driverName.trim()) {
          driverMap.set(driverId, { id: driverId.toString(), name: driverName });
        }
      }
    });

    return Array.from(driverMap.values());
  }, [data]);

  const trucks = useMemo(() => {
    const truckMap = new Map<number, { id: string; name: string }>();

    data?.forEach((shift) => {
      if (shift.truck) {
        const truckId = Number(shift.truck.id);
        const truckName = shift.truck.plateNumber;

        if (!truckMap.has(truckId) && truckName && truckName.trim()) {
          truckMap.set(truckId, { id: truckId.toString(), name: truckName });
        }
      }
    });

    return Array.from(truckMap.values());
  }, [data]);

  return { drivers, trucks };
};
